import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { serviceCities, serviceCounties, site } from '../../data/site';
import { container } from '../../utils/styles';
import { SectionHeading } from './SectionHeading';
interface ServiceAreaSectionProps {
  background?: 'white' | 'cream';
}
export function ServiceAreaSection({
  background = 'white'
}: ServiceAreaSectionProps) {
  const {
    t
  } = useLanguage();
  return <section className={`py-20 sm:py-24 ${background === 'cream' ? 'bg-cream' : 'bg-white'}`} aria-labelledby="area-heading" data-id="element-417" data-mp="1u2mg0e94nuc8">
      <div className={`${container} grid gap-12 lg:grid-cols-12 lg:items-center`} data-id="element-418" data-mp="1g3ms58tfvjh4">
        <div className="lg:col-span-5" data-id="element-419" data-mp="1l1o8hlzhd4ow">
          <SectionHeading id="area-heading" title={t({
          en: 'Service Area',
          es: 'Área de Servicio'
        })} intro={t({
          en: 'We proudly serve families throughout Northern Virginia, from our home base in Woodbridge.',
          es: 'Servimos orgullosamente a familias en todo el norte de Virginia, desde nuestra sede en Woodbridge.'
        })} data-id="element-420" data-mp="1l2r3o63u5tam" />
          <h3 className="mt-8 font-sans text-sm font-semibold text-ink-soft" data-id="element-421" data-mp="2c36kryrruvkr">{t({
            en: 'Cities',
            es: 'Ciudades'
          })}</h3>
          <ul className="mt-3 flex flex-wrap gap-2" data-id="element-422" data-mp="2px7a61wu368g">
            {serviceCities.map(city => <li key={city} className="inline-flex items-center gap-1.5 rounded-full bg-brand-tint px-4 py-2 font-medium text-brand-dark" data-id="element-423" data-mp="2ky32xgtgzikr">
                <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-424" data-mp="1t5c8nbvck3y5" />
                {city}
              </li>)}
          </ul>
          <h3 className="mt-6 font-sans text-sm font-semibold text-ink-soft" data-id="element-425" data-mp="2766d5jf9xkrj">{t({
            en: 'Counties',
            es: 'Condados'
          })}</h3>
          <ul className="mt-3 grid gap-x-6 gap-y-2 text-ink sm:grid-cols-2" data-id="element-426" data-mp="227v6fhk9zqdj">
            {serviceCounties.map(c => <li key={c.en} className="flex items-center gap-2" data-id="element-427" data-mp="3dkxlu9an29w4">
                <span className="h-1.5 w-1.5 rounded-full bg-sage" aria-hidden="true" data-id="element-428" data-mp="3dmrxex00spnj" />
                {t(c)}
              </li>)}
          </ul>
          <p className="mt-6 text-ink-soft" data-id="element-429" data-mp="3pm6z9bcetl8v">
            {t({
            en: 'Not sure if we reach you? Call — we often serve surrounding areas too.',
            es: '¿No sabes si llegamos a tu zona? Llámanos, también atendemos áreas cercanas.'
          })}
          </p>
        </div>
        <div className="overflow-hidden rounded-2xl border border-mist lg:col-span-7" data-id="element-430" data-mp="31y5nltjxpop8">
          <iframe title={t({
          en: 'Map of A.M. Home Care service area in Northern Virginia',
          es: 'Mapa del área de servicio de A.M. Home Care en el norte de Virginia'
        })} src={site.mapEmbedUrl} className="block h-[340px] w-full sm:h-[440px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-431" data-mp="36vxr7ktxyz99" />
        </div>
      </div>
    </section>;
}